import api from '../api'
import {
  ShopProduct,
  CartProduct,
  CartProductUpdate,
  ShipmentFees
} from './interfaces'

export async function ApiGetCart(): Promise<CartProduct[]> {
  const { data } = await api.get<CartProduct[]>('/website/cart')

  return data
}

export async function ApiAddItemToCart(
  product: CartProductUpdate
): Promise<any> {
  const { data } = await api.post(`/website/cart`, { item: product })

  return data
}

export async function ApiClearCart(): Promise<any> {
  const { data } = await api.delete(`/website/cart`)

  return data
}

export async function ApiUpdateCartItem(
  purchaseNo: string,
  quantity: number
): Promise<any> {
  const { data } = await api.put(`/website/cart/${purchaseNo}`, { quantity })

  return data
}

export async function ApiRemoveFromCartItem(purchaseNo: string): Promise<any> {
  const { data } = await api.delete(`/website/cart/${purchaseNo}`)

  return data
}

export async function ApiGetShopProduct(
  purchaseNo: string
): Promise<ShopProduct> {
  const { data } = await api.get<ShopProduct>(
    `/website/shop-product/${purchaseNo}`
  )

  return data
}

export async function ApiGetShipmentFees(): Promise<ShipmentFees[]> {
  const { data } = await api.get<ShipmentFees[]>('/website/shipment-fees')

  return data
}
